var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"toggle"},[_c('input',{staticClass:"toggle__input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":(e) => _vm.onChange(e.target.checked)}}),_vm._v(" "),_c('div',{staticClass:"toggle__fill"})])
}
var staticRenderFns = []

export { render, staticRenderFns }